import { Stack, Tooltip } from '@mui/material';
import {
    DataGridPro,
    DataGridProProps,
    GridToolbarContainer,
    GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';
import { LicenseInfo } from '@mui/x-license';
import { ruRU } from '@mui/x-data-grid/locales';
import { uuidHelper } from '@tap/utils';

/*
*   Таблица DataGridPro (XGrid)
*/

LicenseInfo.setLicenseKey('4a9d79ec086e87806b702c7bc5c6e644Tz0xMTIyNDIsRT0xNzc3NTkzNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=');

export type XGridTableProps = DataGridProProps & {
    hasError?: boolean,
    errorMessage?: string,

}

export const CustomToolbarFilterButton = ({ disabled }: { disabled?: boolean }) =>
    <GridToolbarFilterButton
        slotProps={{
            button: { disabled },
        }}
    // disableHoverListener={true}
    />

export const CustomBaseTooltip = ({ children, ...props }: any) => <Tooltip {...props} ><>{children}</></Tooltip>;



export const CustomToolbar = ({ rows }: { rows: any }) =>
    <GridToolbarContainer sx={{ padding: '4px 5px' }}>
        <CustomToolbarFilterButton disabled={!rows?.length} />
    </GridToolbarContainer>

export const CustomNoRowsOverlay = ({ text = 'Пусто' }: { text?: string }) =>
    <Stack
        height="100%"
        alignItems="center"
        justifyContent="center"
        sx={{ fontWeight: 800 }}
    >
        {text}
    </Stack>


export const ErrorOverlay = ({ text = 'При получении данных возникла ошибка' }: { text?: string }) =>
    <Stack
        height="100%"
        alignItems="center"
        justifyContent="center"
        sx={{ fontWeight: 800 }}
    >
        {text}
    </Stack>

export const CustomNoResultsOverlay = () =>
    <Stack
        height="100%"
        alignItems="center"
        justifyContent="center"
        sx={{ fontWeight: 400 }}
    >
        Ни одно значение не удовлетворяет заданному фильтру
    </Stack>




export function XGridTable({ hasError, errorMessage, ...tableProps }: XGridTableProps) {

    return (
        <DataGridPro
            hideFooter
            disableColumnSelector
            disableRowSelectionOnClick
            disableColumnMenu
            {...tableProps}
            getRowId={tableProps?.getRowId ?? ((row) => row.id ?? uuidHelper.randomUUID())}
            localeText={{
                ...ruRU.components.MuiDataGrid.defaultProps.localeText,
                filterOperatorDoesNotContain: 'не содержит',
                filterOperatorDoesNotEqual: 'не равен',
                noRowsLabel: 'Пусто',
                ...tableProps.localeText,
            }}
            sx={{
                '& .MuiDataGrid-iconSeparator': {
                    display: 'none',
                },
                '.MuiDataGrid-columnSeparator': {
                    width: '0px',
                    minHeight: '55px !important',
                    backgroundColor: '#E0E0E0',
                    borderLeft: '1px solid #F5F5F5',
                    borderRight: '1px solid #F5F5F5',
                    padding: '0px 0.5px',
                },
                '& .MuiDataGrid-iconButtonContainer': {
                    display: 'none !important',
                },
                '& .MuiDataGrid-columnHeader:focus': {
                    outline: 'none',
                },
                '& .MuiDataGrid-columnHeader--alignRight': {
                    justifyContent: 'justify-content-end',
                    textAlign: 'right',
                },
                '& .MuiDataGrid-columnHeadersInner': {
                    alignItems: 'flex-start',
                },
                '& .MuiDataGrid-columnHeader': {
                    backgroundColor: '#F5F5F5',
                },
                '& .MuiDataGrid-columnHeaderTitleContainerContent > *': {
                    fontSize: '12px',
                    fontWeight: 700,
                    whiteSpace: 'break-spaces',
                    lineHeight: 1.3,
                    '> .MuiDataGrid-columnHeader--filtered': {
                        visibility: 'hidden !important',
                    },
                },
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#F5F5F5',
                    borderTop: tableProps?.slots?.toolbar === null ? 'none' : '1px solid #E0E0E0',
                    borderTopLeftRadius: tableProps?.slots?.toolbar === null ? '4px' : '0px',
                    borderTopRightRadius: tableProps?.slots?.toolbar === null ? '4px' : '0px',
                },
                '& .MuiDataGrid-cell': {
                    fontWeight: 400,
                    lineHeight: 1.65,
                    alignContent: 'center',
                },
                '.red-value': {
                    fontWeight: '700 !important',
                    color: '#eb0000',
                },
                '.green-value': {
                    fontWeight: '700 !important',
                    color: 'rgb(77, 182, 172)',
                },
                '.gray-value': {
                    color: '#999999',
                },
                '& .MuiLink-root, .MuiGrid-item, .MuiTypography-root, .MuiButton-root, .MuiDataGrid-cell': {
                    fontSize: '12px',
                },
                '& .MuiDataGrid-cell:focus-within': {
                    outline: 'none',
                },
                ...(tableProps.sx || {}),
            }}

            slots={{
                toolbar: () => <CustomToolbar rows={tableProps.rows} />,
                noRowsOverlay: () => hasError
                    ? <ErrorOverlay text={errorMessage} />
                    : <CustomNoRowsOverlay text={tableProps.localeText?.noRowsLabel} />,
                noResultsOverlay: CustomNoResultsOverlay,
                baseTooltip: CustomBaseTooltip,
                ...(tableProps.slots || {}),
            }}
            slotProps={{
                baseTooltip: {
                    disableHoverListener: true,
                },
                ...(tableProps.slotProps || {}),
            }}
        />
    );
}